<script setup lang="ts">
import { defineModel } from 'vue';

import Button from 'primevue/button';

import { useSelectViewItems } from '@/composables/useSelectViewItems';
import { useViewNavigation } from '@/composables/useViewNavigation';

const selectedItems = defineModel<{ [key: string]: number | null }>('selectedItems', {
  type: Object,
  required: true,
});

const {
  nextGroupButton,
  prevGroupButton,
  nextElementButton,
  getNextNotSkipableGroup,
} = useViewNavigation();

const { handleNextGroup } = useSelectViewItems(selectedItems);
</script>

<template>
  <div class="flex justify-center gap-6">
    <RouterLink v-if="prevGroupButton.route" :to="prevGroupButton.route">
      <Button class="font-semibold" severity="secondary" outlined size="small">
        {{ prevGroupButton.title }}
      </Button>
    </RouterLink>

    <Button
      v-if="nextElementButton"
      class="font-semibold"
      size="small"
      outlined
      @click="handleNextGroup(nextElementButton.route)"
    >
      <i class="pi pi-plus" />
      {{ nextElementButton.title }}
    </Button>

    <Button
      v-if="nextGroupButton.route"
      class="font-semibold"
      size="small"
      @click="handleNextGroup(nextGroupButton.route)"
    >
      {{ nextGroupButton.title }}
    </Button>

    <RouterLink
      v-if="getNextNotSkipableGroup()"
      :to="{
        ...getNextNotSkipableGroup(),
      }"
    >
      <Button class="font-semibold" size="small" outlined> Pomiń opcjonalne kroki </Button>
    </RouterLink>
  </div>
</template>
